import { t } from "../i18n";
import PropTypes from 'prop-types';
import { AmplifyProvider, RequireAuth } from 'aws-auth-lib';
import { CircularProgress, Stack, Typography } from '@mui/material';
import { awsAuthConfig } from '../configs/aws';
import { AuthProvider } from './AuthProvider';

// RequireAuth waits for the library's bundled Amplify instance to be configured.
// Each session transition also resets the portal's user, role and query cache.
export default function AuthSessionGate({
  children
}) {
  const guestPortal = () => <AuthProvider key="guest">{children}</AuthProvider>;
  return <AmplifyProvider config={awsAuthConfig}>
            <RequireAuth action={guestPortal} loader={<Stack alignItems="center" spacing={2} sx={{
      py: 10
    }} role="status">
                    <CircularProgress />
                    <Typography>{t("A verificar a sessão…")}</Typography>
                </Stack>}>
                <AuthProvider key="authenticated">{children}</AuthProvider>
            </RequireAuth>
        </AmplifyProvider>;
}
AuthSessionGate.propTypes = {
  children: PropTypes.node.isRequired
};
